import {
  borderLeftRadius,
  borderTopRadius,
  mq,
} from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const DEFAULT_IMAGES = {
  PORTRAIT: {
    altText: `Resource`,
    name: `xSImage`,
    url: `/media/cover-mobile-resources-generic.svg`,
  },
  LANDSCAPE: {
    altText: `Resource`,
    name: `xSUpImage`,
    url: `/media/cover-resources-generic.svg`,
  },
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  overflow: hidden;
  flex-shrink: 0;

  /* stylelint-disable-next-line */
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  mask-image: radial-gradient(white, black);
  ${borderLeftRadius(0.5)}

  > *:last-child {
    display: none;
  }

  /* stylelint-disable-next-line */
  > * {
    display: block;
    image-rendering: smooth;
    transition: transform 0.25s ease-in-out;
    will-change: transform;
    width: 100%;
  }

  ${mq(`smallUp`)} {
    ${borderTopRadius(0.5)}
    border-bottom-left-radius: 0;

    > *:first-child {
      display: none;
    }

    > *:last-child {
      display: block;
    }
  }
`

const Image = styled.img.attrs((props) => ({
  className: `illustration`,
  alt: props.altText,
  src: props.url,
}))``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const CardImage = ({ image }) => {
  // Ensure default images are applied. We can't use defaultProps because the
  // image object could include only one of the images and not trigger the
  // default.
  const { portrait, landscape } = image

  const resolvedPortrait = portrait || DEFAULT_IMAGES.PORTRAIT
  const resolvedLandscape = landscape || DEFAULT_IMAGES.LANDSCAPE

  return (
    <Layout>
      <Image {...resolvedPortrait} />
      <Image {...resolvedLandscape} />
    </Layout>
  )
}

CardImage.propTypes = {
  image: PropTypes.object,
}

CardImage.defaultProps = {
  image: {},
}

export default CardImage
